var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const showVariantThumbnail = (imageThumbnails, productHandle) => __awaiter(void 0, void 0, void 0, function* () {
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);
    const currentVariant = urlParams.get('variant');
    imageThumbnails.forEach((image) => {
        image.classList.remove('product__thumb-item--current-variant');
    });
    yield fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
        .then((data) => data.json())
        .then((product) => {
        if (product && product.variants) {
            const variants = product.variants;
            variants.forEach((variant) => {
                var _a;
                if (variant.id == currentVariant) {
                    const featuredImageID = (_a = variant.featured_media) === null || _a === void 0 ? void 0 : _a.id;
                    if (featuredImageID) {
                        const imageThumbnail = document.querySelector('.product__thumb-item[data-id="' + featuredImageID + '"]');
                        if (imageThumbnail) {
                            imageThumbnail.classList.add('product__thumb-item--current-variant');
                        }
                    }
                }
            });
        }
    });
});
const productGalleryThumbnails = () => {
    const variantInputs = document.querySelectorAll('[data-variant-input]');
    const productSection = document.querySelector('[data-section-type="product"]');
    if (productSection) {
        const productHandle = productSection.getAttribute('data-product-handle');
        const imageThumbnails = document.querySelectorAll('.product__thumb-item');
        if (productSection && variantInputs && productHandle && imageThumbnails) {
            variantInputs.forEach((input) => {
                input.addEventListener('change', () => {
                    showVariantThumbnail(imageThumbnails, productHandle);
                });
            });
            setTimeout(() => {
                showVariantThumbnail(imageThumbnails, productHandle);
            }, 100);
        }
    }
};
export default productGalleryThumbnails;
